//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Response$AdminUserController_getCurrentUser$Status$200,
  ResponseContentType$AdminUserController_getCurrentUser,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useAdminUserController_getCurrentUser = (options?: {
  config?: QueryOptions<
    Response$AdminUserController_getCurrentUser$Status$200[ResponseContentType$AdminUserController_getCurrentUser]
  >;
}) =>
  useApiClient<
    never,
    Response$AdminUserController_getCurrentUser$Status$200[ResponseContentType$AdminUserController_getCurrentUser]
  >({
    method: 'AdminUserController_getCurrentUser',
    config: options?.config,
  });
